export default __webpack_public_path__ + "static/media/IF_MyStrengths_StrengthDesc_05.e450b8d5.jpg";